// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Which catalog option the customer picked. A product is its name; a custom bundle built on a product (AUT-6630) is its
// own id, since a bundle may share its product's name and both carry the product's _id.
export const catalogOptionKey = ({ name, customBundleId }: { name: string, customBundleId?: string }): string => (
  customBundleId ? `bundle:${customBundleId}` : name
);

export default catalogOptionKey;
